export function stringToUrl(str) {
    return str?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "")?.replace(/đ/g, "d")?.replace(/Đ/g, "D")?.toLowerCase()?.replace(/[^a-z0-9\s-]/g, "")?.replace(/\s+/g, "-")?.replace(/-+/g, "-")?.replace(/^-|-$/g, "")??'';
  }
  